const trackUtils = require('../../tracking/trackUtils');

class SectionLoadUtils 
{

  /**
   * Only modify current url to section
   * @param $elm
   */
  static changeUrl($elm) {
    let section = $elm.data('section');
    let segment = '';
    if (section === 'main') {
      segment = '/';
    } else {
      segment = $elm.data('section-url');
    }
    segment += window.location.search + window.location.hash;

    history.replaceState({"section": section}, section, segment);
  }

  /**
   * Change section name in header
   * @param $elm
   */
  static changeSectionName($elm) {
    Logger.info('[Header][Sticky] Change section name');
    if (Voonto.is.mobile() === true) {
      let $stickySectionName = Voonto.$('.cabecera-sticky .nombre-seccion>a');
      let nsChannel = window.vocento.tracking.comscore.voc_site;
      let nsLinkname = window.vocento.tracking.comscore.voc_se;
      let trackingMark = '#ns_campaign=logo-seccion&ns_mchannel='+nsChannel+'&ns_source=portada.portada&ns_linkname='+nsLinkname+'&ns_fee=0';
      
      if ($elm.data('section') === 'main') {
          $stickySectionName.attr("href", '/' + trackingMark);
          $stickySectionName.text('Portada');
      } else {
          $stickySectionName.attr("href", $elm.data('section-url') + trackingMark);
          $stickySectionName.text($elm.data('section-name'));
      }
    }else{
      let nsChannel = window.vocento.tracking.comscore.voc_site;

      let nsLinkname = window.vocento.tracking.comscore.voc_se;
      if ($elm.data('section') === 'main') {
          if (window.vocento.tracking.comscore.voc_s1.length > 0) {
              nsLinkname = nsLinkname + '.' + window.vocento.tracking.comscore.voc_s1;
          }
      }
      else {
          nsLinkname = $elm.data('tracking').comscore.voc_se;
          if ($elm.data('tracking').comscore.voc_s1.length > 0) {
              nsLinkname = nsLinkname + '.' + $elm.data('tracking').comscore.voc_s1;
          }
      }

      let trackingMark = '#ns_campaign=logo-seccion&ns_mchannel='+nsChannel+'&ns_source=portada.portada&ns_linkname='+nsLinkname+'&ns_fee=0';

      let $stickySectionName = Voonto.$('.cabecera-sticky .titulo-seccion>a');
      if ($elm.data('section') === 'main') {
          $stickySectionName.attr("href", '/' + trackingMark);
          $stickySectionName.text('Portada');
      } else {
          $stickySectionName.attr("href", $elm.data('section-url') + trackingMark);
          $stickySectionName.text($elm.data('section-name'));
      }
    }

  }

  /**
   * Unbind click on section title an bind on with last section
   * @param $elm
   */
  static onClickSectionName($elm) {
    if (Voonto.is.desktop()) {
      let $sectionName = $('.cabecera-sticky > span > .titulo-seccion');
      $sectionName.off('click');
      $sectionName.on('click', function () {
        history.replaceState({section: 'main', lastSectionView: $elm.data('section')}, 'main', '/'+window.location.search);
      });
    }
    else if (Voonto.is.mobile()) {
      let $sectionName = $('.nombre-seccion');
      $sectionName.off('click');
      $sectionName.on('click', function () {
        history.replaceState({section: 'main', lastSectionView: $elm.data('section')}, 'main', '/'+window.location.search);
      });
    }
  }

  /**
   * Listen all click events to replace history
   * @param $elm
   */
  static onClickSetHistoryHome($elm) {
    $elm.find('a').on('click', function () {
        let $link = Voonto.$(this);
        let target = $link.attr('target');
        if (target && target !== '_self') {
          return;
        }

        let lastSectionView = 'main';
        let $parent = $link.closest("[data-section]");
        if ($parent) {
          lastSectionView = $parent.data('section');
        }
        history.replaceState({section: 'main', lastSectionView: lastSectionView}, 'main', '/'+window.location.search);
    });
  }

  static onClickTerrazaHome($elm) {
    $elm.find('a').on('click', function () {
        let $link = Voonto.$(this);
        let target = $link.attr('target');
        if (target && target !== '_self') {
          return;
        }
        
        let lastSectionView = 'main';
        let $prev = $link.parentsUntil('main').last().prev("[data-section]");
        if ($prev) {
          lastSectionView = $prev.data('section');
        }

        history.replaceState({section: 'main', lastSectionView: lastSectionView}, 'main', '/'+window.location.search);
    });
  }

  static onClickSectionMenu($elm) {
    $elm.on('click', function () {
      $elm.next().slideToggle();
    });

    $elm.on('click', function () {
      let tipoAnimacion = $elm.data('boton-animado');
      Logger.info('tipoAnimacion ' + tipoAnimacion);
      switch (tipoAnimacion) {
        case 'menu':
          $elm.toggleClass('abierto');
      }
    });
  }

  static onClickMainHome($elm) {
    $elm.find('a').on('click', function () {
        window.scrollTo(0, 0);
        location.reload();
    });
  }

  /** populate vars into global scope and track with vtm */
  static tracking($elm) {
    try {
      let tracking = null;

      /** if is section, get tracking from data */
      if ($elm.data('section') !== 'main' && typeof $elm.data('tracking') !== 'undefined') {
        tracking = $elm.data('tracking');
      }

      /** if is main section, get data from main object */
      if ($elm.data('section') === 'main') {
        tracking = window.vocento.tracking;
      }

      Logger.info('Tracking section: ' + $elm.data('section'));

      Voonto.getInstance().when('vtm:ready').then(function() {
        TagManager.set({
          seccion:                  tracking.comscore.voc_se,
          subseccion1:              tracking.comscore.voc_s1,
          subseccion2:              tracking.comscore.voc_s2,
          subseccion3:              tracking.comscore.voc_s3,
          subseccion4:              tracking.comscore.voc_s4,
          titular:                  tracking.comscore.voc_tn,
          tipoDominio:              tracking.comscore.voc_pr,
          edicion:                  tracking.comscore.voc_ed,
          tipoContenido:            tracking.comscore.voc_tc,
          tipoContenidoA:           tracking.comscore.voc_tcnew,
          plataformaContenido:      tracking.comscore.voc_pl,
          sistemaPublicacion:       tracking.comscore.voc_pu,
          fechaPrimeraPublicacion:  tracking.comscore.voc_fep,
          fechaModificacion:        tracking.comscore.voc_fem,
          idioma:                   tracking.comscore.voc_idi,
          IDEvolok:                 tracking.comscore.voc_pw_pid,
          firmaAutor:               tracking.comscore.voc_au,
          origenContenido:          tracking.comscore.voc_or,
          topics:                   tracking.comscore.voc_top,
          scrollInfinito:           true,
          scrollInfinitoHome:       $elm.data('section-seq'),
          scrollDireccion:          window.vocento.tracking.comscore.scrollDireccion

        }).track();

        Logger.info('VTM dataLayer');
        Logger.info(TagManager.get());

        /** GTM datalayer scroll push event */
        window.dataLayer.push(
          {'event': 'scrollview',}
        );
      }, function (reason) {
        trackUtils.imgTrack('vtm-ready-error-section', reason);
        Logger.error('Error while vtm:ready promise: ', reason);
      });
    } catch (ex) {
      trackUtils.imgTrack('vtm-error-exception-section', ex);
      Logger.error('Exception while tracking section: ', ex);
    }
  }

  /**
   * return true if is back view
   * @return {boolean}
   */
  static isBackView() {
    return typeof history.state !== 'undefined' && history.state !== null && typeof history.state.lastSectionView !== 'undefined';
  }

  static disableHomeTopAds() {
    Voonto.$('[data-voc-vam-position]').each(function(k,v){
      let $v = Voonto.$(v);
      $v.attr('data-voc-vam-position-back', $v.attr('data-voc-vam-position'));
      $v.removeAttr('data-voc-vam').removeAttr('data-voc-vam-position');
    });
  }

  static enableHomeTopAds() {
    Voonto.$('[data-voc-vam-position-back]').each(function(k,v){
      let $v = Voonto.$(v);
      $v.attr('data-voc-vam-position', $v.attr('data-voc-vam-position-back'));
      $v.attr('data-voc-vam','');
    });
  }

};

export default SectionLoadUtils;


// WEBPACK FOOTER //
// ./src/scripts/home/sectionLoadUtils.js